module.exports = __webpack_public_path__ + "static/media/BQ Logo Blue.d15625cd.png";